import { resolveColumnName } from "building-common/columns/columnQuery";
import type { Building } from "building-types/building/buildingTypes";
import type { BuildingAnalyticEntity } from "building-types/buildingAnalyticEntityTypes";
import { COLUMN } from "building-types/buildingGeomTag/buildingGeomTagTypes";
import type { BuildingEntityHandle } from "building-types/entities/buildingEntityHandle";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { RWTable, Table } from "common/data/table";
import { materialSrcFromPalette } from "doc/materialLookup";
import { addAnalyticExtrusion } from "../utils/generateUtil";
import makeBuildingSelector from "../utils/makeBuildingSelector";
import memo from "../utils/memo";

export function addColumnAnalyticEntities(
  building: ReturnType<typeof select>,
  buildingEntityHandle: BuildingEntityHandle,
): Table<BuildingAnalyticEntity> {
  const entities: RWTable<BuildingAnalyticEntity> = {};
  if (buildingEntityHandle.entityType !== "COLUMN") {
    return entities;
  }
  const column = building.columns[buildingEntityHandle.id];
  if (!column) {
    return entities;
  }
  const name = resolveColumnName(column, building.doc.columns, building.settings.column);
  const generatedHandle: DocEntityHandle = { type: "GENERATED_ENTITY", entity: buildingEntityHandle };
  for (const extrusion of column.extrusions) {
    addAnalyticExtrusion(
      "ANALYTIC_COLUMN",
      entities,
      name,
      [column.handle, generatedHandle],
      extrusion,
      materialSrcFromPalette(building.exteriorPalette, column.paletteId),
      [COLUMN],
    );
  }
  return entities;
}

const select = makeBuildingSelector(["columns", "doc", "settings", "exteriorPalette"]);

function generate(building: ReturnType<typeof select>): Pick<Building, "analyticColumnEntities"> {
  const analyticColumnEntities: RWTable<BuildingAnalyticEntity> = {};
  for (const id of Object.keys(building.columns)) {
    Object.assign(analyticColumnEntities, addColumnAnalyticEntities(building, { entityType: "COLUMN", id }));
  }
  return { analyticColumnEntities };
}

export default memo(select, generate);
